const localization = {
  theHouse: {
    nl: 'Het huis',
    de: 'Das Haus',
    en: 'The house'
  },
  activities: {
    nl: 'Activiteiten',
    de: 'Aktivitäten',
    en: 'Activities'
  },
  surroundings: {
    nl: 'Omgeving',
    de: 'Die Umgebung',
    en: 'Surroundings'
  },
  contactUs: {
    nl: 'Contact',
    de: 'Kontakt',
    en: 'Contact'
  }
}

module.exports = Object.freeze(localization)



// WEBPACK FOOTER //
// ./src/localization/navigation.js